const bucketUrl = 'https://storage.googleapis.com/bitte-public';

const tokensUrl = `${bucketUrl}/intents/tokens`;

const chainsUrl = `${bucketUrl}/intents/chains`;

export const TOKEN_ICONS: Record<string, string> = {
  BTC: `${tokensUrl}/btc_token.svg`,
  ETH: `${tokensUrl}/eth_token.svg`,
  wETH: `${tokensUrl}/eth_token.svg`,
  wBTC: `${tokensUrl}/btc_token.svg`,
  NEAR: `${chainsUrl}/near.svg`,
  wNEAR: `${chainsUrl}/near.svg`,
  USDC: `${tokensUrl}/usdc_token.svg`,
  USDT: `${tokensUrl}/usdt_token.svg`,
  XDAI: `${tokensUrl}/xdai_token.svg`,
  DAI: `${tokensUrl}/xdai_token.svg`,
  SOL: `${tokensUrl}/sol_token.svg`,
  SUI: `https://s2.coinmarketcap.com/static/img/coins/64x64/20947.png`,
};

export const CHAIN_ICONS: Record<string, string> = {
  eth: `${chainsUrl}/eth.svg`,
  ethereum: `${chainsUrl}/eth.svg`,
  base: `${chainsUrl}/base.svg`,
  'base sepolia': `${chainsUrl}/base.svg`,
  basesepolia: `${chainsUrl}/base.svg`,
  arb: `${chainsUrl}/arbi.svg`,
  arbitrum: `${chainsUrl}/arbi.svg`,
  gnosis: `${chainsUrl}/gnosis.svg`,
  near: `${chainsUrl}/near.svg`,
  polygon: `${chainsUrl}/polygon.svg`,
  matic: `${chainsUrl}/polygon.svg`,
  op: `${chainsUrl}/op.svg`,
  optimism: `${chainsUrl}/op.svg`,
  avax: `${chainsUrl}/avax.svg`,
  avalanche: `${chainsUrl}/avax.svg`,
  bnb: `${chainsUrl}/bnb.svg`,
  bsc: `${chainsUrl}/bnb.svg`,
  sol: `${chainsUrl}/sol.svg`,
  sui: `https://s2.coinmarketcap.com/static/img/coins/64x64/20947.png`,
  unichain: `${bucketUrl}/unichain.webp`,
  sonic: `${bucketUrl}/sonic.webp`,
  soneium: `${bucketUrl}/soneium.webp`,
  berachain: `${bucketUrl}/berachain.webp`,
  bera: `${bucketUrl}/berachain.webp`,
};

export const getTokenIcon = (symbol: string): string | undefined => {
  return TOKEN_ICONS[symbol.toUpperCase()];
};

export const getChainIcon = (chain: string): string | undefined => {
  return CHAIN_ICONS[chain.toLowerCase()];
};
